export default __webpack_public_path__ + "static/media/darkTheme.ea5e38ec.png";